// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33iiV","option":"styles_option__2vy2e","selected":"styles_selected__27I6s"};